/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Trust_Priority_SupportInputs */



/**
* | output |
* | --- |
* | "24/7 priority support" |
*
* @param {Pricing_Trust_Priority_SupportInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_trust_priority_support = /** @type {((inputs?: Pricing_Trust_Priority_SupportInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Trust_Priority_SupportInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("24/7 priorisierter Support")
	return /** @type {LocalizedString} */ ("24/7 priority support")
});